import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { concatLatestFrom } from '@ngrx/operators';
import { Store } from '@ngrx/store';
import { selectI18N } from '@src/suite/common/store/i18n/selectors/i18n.selectors';
import { calculatePropComparators } from '@src/suite/common/utils/global-tables.utils';
import { map } from 'rxjs';

import { GlobalTablesActions } from './global-tables.actions';

@Injectable()
export class GlobalTablesEffects {
    actions$ = inject(Actions);
    store = inject(Store);

    loadStoryTemplates$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(GlobalTablesActions.processGlobalFields),
            concatLatestFrom(() => this.store.select(selectI18N)),
            map(([action, i18n]) => {
                const groupSort = calculatePropComparators(action.fields, i18n);
                return GlobalTablesActions.setGlobalFields({ fields: action.fields, groupSortDefs: groupSort });
            })
        );
    });
}
